// frontend/src/pages/ProjectGeneral.tsx
import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { useProjectFormStore } from "@/store/project-form-provider";
import { ProjectInputField } from "@/components/project-input-field";
import { ProjectSaveButton } from "@/components/project-save-button";
import { ProjectResetButton } from "@/components/project-reset-button";
// import { useProjectForm } from "@/utils/use-project-form";

export default function ProjectGeneral() {
  const { loading, error, formData, updateField, saveAll, resetAll, savingAll, getFieldType, getFieldOptions,
  } = useProjectFormStore();
  // const { loading, error, formData, updateField, saveAll, resetAll, savingAll, projectFieldMetadata, } = useProjectFormStore();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    updateField(name, value);
  };

  const { t } = useTranslation();

  if (loading) return <div className="p-4 text-xs">{t("common.loading")}</div>;
  if (error || !formData) return <div className="p-4 text-elani text-xs">{t("common.error_loading_data")}</div>;

  return (
    <form className="max-w-md space-y-8 text-xs">
      <div className="space-y-2">
        <ProjectInputField label={t("project.general.project_name")} name="name" value={formData.name} onChange={handleChange} />
        <ProjectInputField label={t("project.general.address")} name="address" value={formData.address} onChange={handleChange} />
        <ProjectInputField label={t("project.general.city")} name="city" value={formData.city} onChange={handleChange} />
        <ProjectInputField label={t("project.general.zip")} name="zip" value={formData.zip} onChange={handleChange} />
        <ProjectInputField label={t("project.general.federal_state")} name="federal_state" value={formData.federal_state} onChange={handleChange} />
        <ProjectInputField label={t("project.general.country")} name="country" value={formData.country} onChange={handleChange} />
      </div>

      <div className="space-y-2">
        <ProjectInputField label={t("project.general.technology")} name="technology" value={formData.technology} onChange={handleChange} />
        <ProjectInputField label={t("project.general.type")} name="type" value={formData.type} onChange={handleChange} />
        <ProjectInputField label={t("project.general.phase")} name="phase" value={formData.phase} onChange={handleChange} />
        <ProjectInputField label={t("project.general.purchasing_year")} name="purchasing_year" value={formData.purchasing_year} onChange={handleChange} />
      </div>

      <div className="pt-3 flex gap-2">
        <ProjectSaveButton onSave={saveAll} saving={savingAll} />
        <ProjectResetButton onReset={resetAll} saving={savingAll} />
      </div>
    </form>
  );
}